'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n'], ['\n  width: 100%;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  color: ', ';\n  background-color: ', ';\n  padding: 20px;\n  font-size: 18px;\n  font-weight: 500;\n  letter-spacing: 1px;\n'], ['\n  color: ', ';\n  background-color: ', ';\n  padding: 20px;\n  font-size: 18px;\n  font-weight: 500;\n  letter-spacing: 1px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  background-color: ', ';\n  padding: 20px;\n'], ['\n  background-color: ', ';\n  padding: 20px;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  margin: 15px 0px;\n  font-weight: bold;\n  font-size: 18px;\n'], ['\n  margin: 15px 0px;\n  font-weight: bold;\n  font-size: 18px;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  font-style: italic;\n  font-weight: 400;\n'], ['\n  font-style: italic;\n  font-weight: 400;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _config = require('../../config.js');

var _TextArea = require('../TextArea');

var _TextArea2 = _interopRequireDefault(_TextArea);

var _YellowLineSVG = require('../../svg/YellowLineSVG');

var _YellowLineSVG2 = _interopRequireDefault(_YellowLineSVG);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.div(_templateObject);

var Header = _styledComponents2.default.h3(_templateObject2, _config.colors.white, _config.colors.darkBlue);

var Body = _styledComponents2.default.div(_templateObject3, _config.colors.white);

var TitleLine = _styledComponents2.default.div(_templateObject4);

var AuthorName = _styledComponents2.default.span(_templateObject5);

/**
# MemberAnnouncement
A component that displays a message from an OSBA staffer.
 */

var MemberAnnouncement = function MemberAnnouncement(_ref) {
  var title = _ref.title,
      headline = _ref.headline,
      content = _ref.content,
      authorName = _ref.authorName;
  return _react2.default.createElement(
    Wrapper,
    null,
    _react2.default.createElement(
      Header,
      null,
      title
    ),
    _react2.default.createElement(
      Body,
      null,
      _react2.default.createElement(_YellowLineSVG2.default, null),
      _react2.default.createElement(
        TitleLine,
        null,
        headline,
        ' ',
        _react2.default.createElement(
          AuthorName,
          null,
          'from ',
          authorName
        )
      ),
      _react2.default.createElement(_TextArea2.default, {
        htmlString: content
      })
    )
  );
};

MemberAnnouncement.propTypes = {
  title: _propTypes2.default.string.isRequired,
  headline: _propTypes2.default.string.isRequired,
  content: _propTypes2.default.string.isRequired,
  authorName: _propTypes2.default.string.isRequired
};

MemberAnnouncement.displayName = 'MemberAnnouncement';

exports.default = MemberAnnouncement;
MemberAnnouncement.__docgenInfo = {
  'description': '# MemberAnnouncement\r\nA component that displays a message from an OSBA staffer.',
  'methods': [],
  'displayName': 'MemberAnnouncement',
  'props': {
    'title': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': ''
    },
    'headline': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': ''
    },
    'content': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': ''
    },
    'authorName': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': ''
    }
  }
};